import { api } from '@/store/api'

import Env from '../../../env/env'

import type {
  CreateProspectRequest,
  CreateProspectResponse,
  AnalyzeProspectRequest,
  AnalyzeProspectResponse,
  VerifyProspectEmailRequest,
  ResendProspectOtpRequest,
} from './PublicForm.types'

export const publicFormApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // useInitProspectSessionMutation
    initProspectSession: builder.mutation<
      CreateProspectResponse,
      CreateProspectRequest
    >({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/public-forms/init-prospect-session`,
        method: 'POST',
        body: {
          email: request.email,
          profilePhoto: request.profilePhoto,
          numberOfSocialAccounts: request.numberOfSocialAccounts,
          language: request.language,
        },
      }),
    }),

    // useAnalyzeProspectMutation
    analyzeProspect: builder.mutation<
      AnalyzeProspectResponse,
      AnalyzeProspectRequest
    >({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/public-forms/analyze-prospect`,
        method: 'POST',
        body: {
          email: request.email,
          ...(request.picture && { picture: request.picture }),
        },
      }),
    }),

    // useVerifyProspectEmailMutation
    verifyProspectEmail: builder.mutation<void, VerifyProspectEmailRequest>({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/public-forms/verify-prospect-email`,
        method: 'POST',
        body: {
          email: request.email,
          otp: request.otp,
        },
      }),
    }),

    // useResendProspectOtpMutation
    resendProspectOtp: builder.mutation<void, ResendProspectOtpRequest>({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/public-forms/resend-code`,
        method: 'POST',
        body: {
          email: request.email,
        },
      }),
    }),
  }),
})

export const {
  useInitProspectSessionMutation,
  useAnalyzeProspectMutation,
  useVerifyProspectEmailMutation,
  useResendProspectOtpMutation,
} = publicFormApi
